import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { getAdobeECID } from '../shared/utils/adobe-ecid';
import { uuid } from '../shared/utils/uuid';
import { RuntimeConfigService } from './runtime-config';

export interface SubmitCapsLeadRestInput {
  agreementConsent: boolean;
  smsConsent?: boolean;
}

export interface DealerApproval {
  dealerId: string;
  approvalNumber: string;
}

export interface SubmitCapsLeadResponse {
  submitCapsLead: boolean;
  leadCreated: boolean;
  /**
   * Per-dealer approval numbers returned by the caps-lead backend. Each
   * `approvalNumber` is the `leadId` for the matching `dealerId`. May be empty
   * (or omit individual dealers) when approval numbers fail to generate.
   */
  dealerApprovals: DealerApproval[];
}

/**
 * Submits CAPS lead consent after the customer agrees on the summary step
 * (`POST /api/application/caps-lead`).
 */
@Injectable({
  providedIn: 'root',
})
export class SubmitCapsLeadRestService {
  constructor(
    private http: HttpClient,
    private readonly runtimeConfigService: RuntimeConfigService
  ) {}

  submitCapsLead(
    agrementConsent: SubmitCapsLeadRestInput
  ): Observable<SubmitCapsLeadResponse> {
    const { WWW_REST_API_URI } = this.runtimeConfigService.prequalConfig;

    return getAdobeECID().pipe(
      take(1),
      switchMap((ecid) => {
        const headers = {
          'x-correlation-id': uuid(),
          'x-ecid': ecid || '',
        };

        return this.http.post<SubmitCapsLeadResponse>(
          WWW_REST_API_URI + '/api/application/caps-lead',
          agrementConsent,
          { headers }
        );
      })
    );
  }
}
